import { Skeleton, Stack } from '@mui/material';

interface Props {
    numFields: number;
}

export default function InfoCardSkeleton({ numFields }: Props) {
    return (
        <Stack
            spacing={2}
            p={3}
            sx={{
                border: '1px solid',
                borderColor: 'neutral.borderColor',
                borderRadius: '4px',
                backgroundColor: 'neutral.white',
                width: '100%',
            }}
        >
            {/* Section title */}
            <Skeleton width={140} height={28} sx={{ mb: 2 }} />

            {/* Fields */}
            <Stack spacing={2}>
                {Array.from({ length: numFields }, (_, i) => (
                    <Skeleton key={i} variant="rounded" height={40} />
                ))}
            </Stack>
        </Stack>
    );
}
